
import * as Components from "./Baldwin"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "baldwin"
}

